export const valueType_SortedEnumerated = 'SortedEnumerated';
export const defaultMissingValue = 'xxx';
export const valueType_Range = 'range';
export const valueType_SubRange = 'sub-range';
export const valueType_Enumerated = 'enumerated';
export const valueType_SubEnumerated = 'sub-enumerated';
export const valueType_EnumElement = 'enum-element';
export const valueType_Tuple = 'tuple';
export const valueType_StandardRange = 'standard-range';
export const valueType_Time = 'time';
export const valueType_TimeRange = 'time-range';
export const valueType_SubTime = 'sub-time';
export const ListOf_VariableTypes = [valueType_Enumerated,
    valueType_Range,
    valueType_SubRange,
    valueType_SubEnumerated,
    valueType_EnumElement,
    valueType_Tuple,
    valueType_StandardRange,
    valueType_TimeRange,
    valueType_Time,
    valueType_SubTime];
//Initial Data Exports
export const valueID_YesNo = '7d8ad7b50ed7dd2fc6fb746132eb79d2';
export const valueID_PosNeg = 'bdce9de53baecc6b88ebdae117ac1d5d';
export const valueID_Yes = '1d7e2d4da55f315eac0030f6ee0d53b0';
export const valueID_No = '56d79ad5401071daccd40675029b86f0';
export const valueID_Suspected = 'a3b8c1d2e4f5061728394a5b6c7d8e9f';
export const valueID_YesSuspectedNo = 'b4c9d2e5f6071829304a5b6c7d8e9f01';
// "Implicit positive" values: the presence of the finding (its variable name) is
// the signal, so the value text adds no information and is suppressed from the
// Advisor display -- e.g. a finding of "Chest pain = Yes" shows just "Chest pain",
// and a CareMap disease suspicion "= Suspected" is hidden the same way. Single
// source of truth for value-text suppression across the cockpit Key Findings
// (RelatedFinding.getValue) and finding-view value rendering.
export const valueIds_ImplicitPositive = [valueID_Yes, valueID_Suspected];
export const isImplicitPositiveValue = (valueId) => !!valueId && valueIds_ImplicitPositive.includes(valueId);
export const valueID_Pos = '01b8a4529c2c39e607020d3c991af81c';
export const valueID_Neg = '3a4045d2f629e7a45383d3203b09ad2a';
export const valueId_IND = 'bdce9de53baecc6b88ebdae117aaaaa0';
export const StaticValue_Yes = {
    _id: valueID_Yes,
    type: valueType_EnumElement, data: { value: 'yes' }
};
export const StaticValue_No = {
    _id: valueID_No,
    type: valueType_EnumElement, data: { value: 'no' }
};
export const StaticValue_Suspected = {
    _id: valueID_Suspected,
    type: valueType_EnumElement, data: { value: 'suspected' }
};
export const StaticValue_Decreased = {
    _id: 'bdce9de53baecc6b88ebdae117aaaaa1',
    type: valueType_EnumElement, data: { value: 'decreased' }
};
export const StaticValue_Normal = {
    _id: 'bdce9de53baecc6b88ebdae117aaaaa2',
    type: valueType_EnumElement, data: { value: 'normal' }
};
export const StaticValue_Increased = {
    _id: 'bdce9de53baecc6b88ebdae117aaaaa3',
    type: valueType_EnumElement, data: { value: 'increased' }
};
const StaticValue_Positive = {
    _id: valueID_Pos,
    type: valueType_EnumElement, data: { value: 'positive' }
};
const StaticValue_Negative = {
    _id: valueID_Neg,
    type: valueType_EnumElement, data: { value: 'negative' }
};
export const StaticValues_EnumElements = [
    StaticValue_Yes,
    StaticValue_No,
    StaticValue_Suspected,
    StaticValue_Decreased,
    StaticValue_Normal,
    StaticValue_Increased,
    StaticValue_Positive,
    StaticValue_Negative,
];
export const ValType_YesNo = {
    _id: valueID_YesNo,
    type: valueType_Tuple,
    data: {
        scope: [
            StaticValue_Yes,
            StaticValue_No
        ],
    }
};
export const ValType_YesSuspectedNo = {
    _id: valueID_YesSuspectedNo,
    type: valueType_Enumerated,
    data: {
        scope: [
            StaticValue_Yes,
            StaticValue_Suspected,
            StaticValue_No
        ],
        subsets: [],
        subsetIds: [],
        props: {
            isOrdered: false,
            isExclusive: true,
        }
    }
};
export const ValType_PosNeg = {
    _id: valueID_PosNeg,
    type: valueType_Tuple,
    data: {
        scope: [
            StaticValue_Positive,
            StaticValue_Negative
        ],
    }
};
export const ValType_IND = {
    _id: valueId_IND,
    type: valueType_Tuple,
    data: {
        scope: [
            StaticValue_Decreased,
            StaticValue_Normal,
            StaticValue_Increased
        ],
    }
};
export const StaticValues_Tuple = [
    {
        ...ValType_YesNo, type: valueType_Tuple,
        data: { scope: ValType_YesNo.data.scope.map(v => v._id), length: 2 }
    },
    {
        ...ValType_PosNeg, type: valueType_Tuple,
        data: { scope: ValType_PosNeg.data.scope.map(v => v._id), length: 2 }
    },
    {
        ...ValType_IND, type: valueType_Tuple,
        data: { scope: ValType_IND.data.scope.map(v => v._id), length: 3 }
    },
];
export const StaticValues_Enumerated = [
    {
        ...ValType_YesSuspectedNo, type: valueType_Enumerated,
        data: {
            scope: ValType_YesSuspectedNo.data.scope.map(v => v._id),
            subsets: [],
            props: { isOrdered: false, isExclusive: true },
        }
    },
];
export const ValType_StandardRange = {
    type: valueType_StandardRange,
    data: {
        fullRange: [0, 0],
        declarationVarIds: [],
        normalValues: [],
    }
};
export const ValType_CompoundRange = {
    type: valueType_Range,
    data: {
        subsets: [],
        subsetIds: [],
        scope: [0, 0],
    }
};
export const ValType_CompoundEnumerated = {
    type: valueType_Enumerated,
    data: {
        scope: [],
        subsets: [],
        subsetIds: [],
        props: {
            isOrdered: false,
            isExclusive: false,
        }
    }
};
export const ValType_Time = {
    type: valueType_Time,
    data: {
        timeRangesIds: [],
        timeRanges: []
    }
};
export const ValType_TimeRange = {
    type: valueType_TimeRange,
    data: {
        timeRange: [undefined, undefined]
    }
};
export const tupleValueMap = {
    'yesno': ValType_YesNo,
    'posneg': ValType_PosNeg,
    'decnorinc': ValType_IND,
};
//# sourceMappingURL=consts.js.map